require('./style/index.scss');
require('./header.js');